













































































import Component from "vue-class-component";
import Vue from "vue";
import store from "../store/store";
import VueI18n from "vue-i18n";
import {Prop} from "vue-property-decorator";
import {ClientService} from "../services/client.service";

type MenuItem = {
  title: string | VueI18n.TranslateResult,
  icon: string,
  href: string,
}

@Component
export default class MenuComponent extends Vue {
  @Prop(Boolean) open: boolean;

  get menu(): MenuItem[] {

    if(this.$store.getters.user === null)
      return [];

    let menu = [{
      title: 'Projects Overview',
      href: '/',
      icon: 'tachometer-alt',
    },
      {
        title: 'Generator',
        href: '/generator',
        icon: 'scroll',
      }
    ];

    if (this.isAdmin) {
      menu.push({
        title: 'Admin',
        href: '/admin',
        icon: 'key',
      });
    }

    return menu;
  }


  get isAdmin() {
    return store.getters.admin;
  }

  public languageSelected(language) {
    this.$store.dispatch('lang_change', language).then(() => {
      this.$i18n.locale = language;
    });
  }

  get currentLanguage() {
    const languages = {
      'de': 'Deutsch',
      'en': 'English'
    }
    return languages[this.$store.state.lang];
  }
}

